import React from 'react';
import "./_filters.scss"
function Filters({ filters, selectedFilter, handleFilter }) {
  return (
    <div className="filters">
        {filters?.map((filter) => (
          <button
            key={filter.value}
            className={`grounds-filter-btn${selectedFilter === filter.value ? ' active' : ''}`}
            onClick={() => handleFilter(filter.value)}
          >
            {filter.label}
          </button>
        ))}
    </div>
  );
}

export default Filters;
